
import Pagination from "../utils/_pagination";

export default class FilterInstructions {

  ready() {
    this.PAGINATION = new Pagination({
      action: 'filter_instructions',
      postsWrapper: '.mtt-instructions-library__grid',
      paginationWrapper: '.pagination-wrapper',
      paginationItem: 'li a',
      loadingWrapper: '.mtt-instructions-library__grid-wrap',
      loadingClass: 'mtt-instructions-library__grid-wrap--loading'
    });

    this.PAGINATION.init();
    this.filterSidebar();
  }

  filterSidebar() {
    const SIDEBAR_ITEMS = document.querySelector('.mtt-filter-sidebar__items');

    if (SIDEBAR_ITEMS) {
      const CHECKBOX_WRAPPERS = SIDEBAR_ITEMS.querySelectorAll('[data-taxonomy-id]');
      let terms = SIDEBAR_ITEMS.getAttribute('data-current-terms');

      // Make sure a post-type + posts per page is set
      this.PAGINATION.setPostsPerPage();
      this.PAGINATION.setPostType();

      // Loop through all the checkboxes and add event listeners
      for (let i = 0; i < CHECKBOX_WRAPPERS.length; i++) {
        const BOX_WRAP = CHECKBOX_WRAPPERS[i];

        BOX_WRAP.addEventListener('click', event => {
          event.preventDefault();
          const BOX = BOX_WRAP.querySelector('input[type="checkbox"]');
          const TAX_ID = BOX_WRAP.getAttribute('data-taxonomy-id');
          const TAX_STR = BOX_WRAP.getAttribute('data-taxonomy-id') + ',';

          this.PAGINATION.startLoading();

          if (BOX.checked) {
            BOX.checked = false;
            terms = terms.replace(TAX_STR, '');
          } else {
            BOX.checked = true;
            terms += TAX_STR;
          }

          this.PAGINATION.setTaxonomy('instruction-theme');
          this.PAGINATION.setTerms(terms);
          this.PAGINATION.resetPageNumber();
          this.PAGINATION.fetchData();
        });
      }
    }
  }

}